export default {
	cards: {
		averageSoldPrice: 'Average sold price',
		highestSoldPrice: 'Highest sold price',
		lowestSoldPrice: 'Lowest sold price',
	},
	header: {
		overThePastYear: 'Over the past year',
	},
};
